import { Panel, PanelGroup } from '@/shared/ui/panel';

const SURFACES = [
  { name: 'phx-bg', label: 'Page background', token: 'var(--phx-bg)' },
  { name: 'phx-surface', label: 'Surface', token: 'var(--phx-surface)' },
  { name: 'phx-surface-2', label: 'Surface 2', token: 'var(--phx-surface-2)' },
  { name: 'phx-surface-3', label: 'Surface 3', token: 'var(--phx-surface-3)' },
];

const TEXTS = [
  { name: 'phx-text', label: 'Text', token: 'var(--phx-text)' },
  { name: 'phx-text-2', label: 'Text 2', token: 'var(--phx-text-2)' },
  { name: 'phx-text-muted', label: 'Muted', token: 'var(--phx-text-muted)' },
  { name: 'phx-text-faint', label: 'Faint', token: 'var(--phx-text-faint)' },
];

const SEMANTIC = [
  { name: 'phx-primary', token: 'var(--phx-primary)' },
  { name: 'phx-success', token: 'var(--phx-success)' },
  { name: 'phx-warning', token: 'var(--phx-warning)' },
  { name: 'phx-danger', token: 'var(--phx-danger)' },
  { name: 'phx-info', token: 'var(--phx-info)' },
  { name: 'phx-draft', token: 'var(--phx-draft)' },
];

const SCALE = ['xs', 'sm', 'md', 'lg', 'xl', 'h3', 'h2', 'h1'] as const;
const SPACING = [
  { key: 1, px: 2 },
  { key: 2, px: 4 },
  { key: 3, px: 6 },
  { key: 4, px: 8 },
  { key: 5, px: 12 },
  { key: 6, px: 16 },
  { key: 7, px: 20 },
  { key: 8, px: 24 },
  { key: 9, px: 32 },
];

function Swatch({ token, name, label }: { token: string; name: string; label?: string }) {
  return (
    <div className="gap-phx-2 flex flex-col">
      <div
        className="rounded-phx border-phx-border-2 h-12 w-full border"
        style={{ background: token }}
      />
      <div className="text-phx-xs text-phx-text">
        <div className="font-semibold">{name}</div>
        {label ? <div className="text-phx-text-muted">{label}</div> : null}
      </div>
    </div>
  );
}

export function FoundationsSection() {
  return (
    <PanelGroup gap={12}>
      <Panel title="Surfaces" icon="layers">
        <div className="gap-phx-4 grid grid-cols-4">
          {SURFACES.map((s) => (
            <Swatch key={s.name} {...s} />
          ))}
        </div>
      </Panel>

      <Panel title="Text colors" icon="info">
        <div className="gap-phx-4 grid grid-cols-4">
          {TEXTS.map((t) => (
            <Swatch key={t.name} {...t} />
          ))}
        </div>
      </Panel>

      <Panel title="Semantic & primary" icon="star">
        <div className="gap-phx-4 grid grid-cols-6">
          {SEMANTIC.map((s) => (
            <Swatch key={s.name} {...s} />
          ))}
        </div>
      </Panel>

      <Panel title="Type scale">
        <div className="gap-phx-3 flex flex-col">
          {SCALE.map((size) => (
            <div key={size} className="gap-phx-5 flex items-baseline">
              <span className="text-phx-xs text-phx-text-muted w-12 tracking-wider uppercase">
                {size}
              </span>
              <span className="text-phx-text" style={{ fontSize: `var(--phx-size-${size})` }}>
                The quick brown fox jumps over the lazy dog
              </span>
            </div>
          ))}
        </div>
      </Panel>

      <Panel title="Spacing scale">
        <div className="gap-phx-3 flex flex-col">
          {SPACING.map((s) => (
            <div key={s.key} className="gap-phx-5 flex items-center">
              <span className="text-phx-xs text-phx-text-muted w-12 tracking-wider uppercase">
                {s.key}
              </span>
              <span className="text-phx-xs text-phx-text-muted w-12 tabular-nums">{s.px}px</span>
              <div className="bg-phx-primary-tint rounded-phx-sm h-3" style={{ width: s.px }} />
            </div>
          ))}
        </div>
      </Panel>
    </PanelGroup>
  );
}
